export default __webpack_public_path__ + "static/media/FacilityCardAssetIcon.e1d2f9cd.svg";